import { EditFilled, UserOutlined, MailOutlined, CaretDownOutlined } from "@ant-design/icons";
import { Menu, Dropdown } from "antd";
import { getStore } from "../../utils/global";

const CheckRole = ({ onChange, actionrole }) => {
  const roles = getStore("roles");
  const icon_map = {
    pen: <EditFilled />,
    user: <UserOutlined />,
    envelope: <MailOutlined />,
  };
  const role = roles.find((role) => role.actionrole === actionrole);

  let menu = (
    <Menu>
      {roles.map((e) => {
        return (
          <Menu.Item
            key={e.key}
            onClick={() => {
              onChange(e);
            }}>
            <div className="checked_role_per">
              {icon_map[e.icon]}&nbsp; {e.name}
            </div>
          </Menu.Item>
        );
      })}
    </Menu>
  );
  return (
    <div className="checked_role">
      <Dropdown overlay={menu} trigger={["click"]}>
        <div className="checked_role_per_active">
          {icon_map[role.icon]}&nbsp; {role.name.toUpperCase()} &nbsp;
          <CaretDownOutlined />
        </div>
      </Dropdown>
    </div>
  );
};

export default CheckRole;
